// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3WYq7","subheader":"ReorderModal_subheader__2tyEW","listWrap":"ReorderModal_listWrap__32wRW"};